<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewDataLocal"
    @vs-close="closeForm">
    <form>
      <div
        class="vs-component vs-con-input-label vs-input mb-5 vs-input-primary"
        style="max-width: 600px; width: 600px">
        <label class="vs-input--label">Select FICO<sup>*</sup></label>
        <vs-input
          icon="search"
          placeholder="Search"
          style="width: 100%"
          v-model="search" />
      </div>
      <div>
        <div class="flex flex-col" style="gap: 10px">
          <vs-checkbox
            v-for="(u, i) in user_assigns"
            :key="i"
            v-model="u.value"
            >{{ u.name }}</vs-checkbox
          >
        </div>
      </div>
    </form>
    <!-- <vs-divider /> -->
    <div class="flex flex-row mt-5" style="gap: 10px">
      <vs-button
        color="warning"
        type="border"
        class="mb-0 w-1/2"
        @click="closeForm"
        >Cancel</vs-button
      >
      <vs-button
        color="danger"
        type="filled"
        class="mb-0 w-1/2 btn-submit"
        @click="submitsForm">
        Submit
      </vs-button>
    </div>
    <!-- <div class="vx-row">
      <div class="vx-col">
      </div>
    </div> -->
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'
import * as moment from 'moment'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    id: String,
    imei: String,
    title: String,
    editMode: Boolean,
    dataEdit: Object,
  },
  mounted() {
    //
  },
  watch: {
    async editMode(val) {
      this.clearFields()
      //
      this.user_assigns =
        this.dataEdit.user_assigns.length > 0
          ? this.dataEdit.user_assigns.map((u) => {
              return {
                name: u.name,
                id: u.id,
                value: true,
              }
            })
          : []
      //
    },
    // images(val) {
    //
    // },
  },
  computed: {
    addNewDataLocal: {
      get() {
        return JSON.parse(this.isOpen)
      },
      set(val) {
        this.closeForm()
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo !== ''
    },
  },
  data() {
    return {
      is_editable: true,
      search: '',
      user_assigns: [],
    }
  },
  methods: {
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.notes = ''
      this.images = []
      this.fileUploadKey++
      this.is_editable = true
    },
    handlePictureChange(e) {
      const selectedFiles = Array.from(e.target.files)
      if (this.images.length + selectedFiles.length <= 3) {
        this.images.push(...selectedFiles)
      } else {
        alert('You can only upload a maximum of 3 images.')
      }
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Files uploaded successfully',
      })
    },
    async submitsForm() {
      // this.loadingBtnStart('btn-submit')
      const assigned_user = this.user_assigns.map((u) => {
        return {
          id: u.id,
          status: u.value,
        }
      })
      const body = {
        id: this.dataEdit._id,
        vehicle_id: this.dataEdit.vehicle_id,
        user_assigns: assigned_user,
      }

      REPO.updateAlertMutation(body)
        .then((res) => {
          this.closeForm()
          this.$root.$emit('reloadNotifAtas')
          if (res.data.status === 'true') {
            this.successUpload()
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: res.data.error_msg,
            })
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: err.data.error_msg,
          })
        })
      // this.loadingBtnStop('btn-submit')
      this.$emit('submitModal', false)
      // this.successUpload()
      // this.closeForm()
      this.$root.$emit('reloadNotifAtas')
    },
  },
}
</script>
<style>
.vs-popup {
  width: auto !important;
}

.img-upload {
  margin-left: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

sup {
  color: red;
}

.fileUpload {
  background: transparent;
  color: #333333;
  font-size: 1em;
  overflow: hidden;
  padding: 0.875em; /*14px/16px*/
  position: relative;
  text-align: center;
  width: fit-content;
  cursor: pointer;
  border: 1px solid var(--Gray-4, #bdbdbd);
}
.fileUpload:hover,
.fileUpload:active,
.fileUpload:focus {
  background: transparent;
  cursor: pointer;
}
.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  width: 148px;
  height: 46px;
  cursor: pointer;
}

input[type='file'] {
  position: fixed;
  right: 100%;
  bottom: 100%;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
